import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Customer } from "@/types/crm";

interface BasicQuoteFieldsProps {
  customers: Customer[];
  formData: {
    customerId: string;
    title: string;
    description: string;
    validUntil: string;
  };
  onUpdateFormData: (field: string, value: string | number) => void;
}

const BasicQuoteFields = ({ customers, formData, onUpdateFormData }: BasicQuoteFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="customer">Customer/Contract *</Label>
          <Select value={formData.customerId} onValueChange={(value) => onUpdateFormData('customerId', value)}>
            <SelectTrigger>
              <SelectValue placeholder="Select customer" />
            </SelectTrigger>
            <SelectContent>
              {customers.map((customer) => (
                <SelectItem key={customer.id} value={customer.id}>
                  {customer.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="title">Quote Title *</Label>
          <Input
            id="title"
            value={formData.title}
            onChange={(e) => onUpdateFormData('title', e.target.value)}
            placeholder="e.g., Land Contract Purchase Quote"
            required
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => onUpdateFormData('description', e.target.value)}
          placeholder="Quote description"
          rows={2}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="validUntil">Valid Until</Label>
        <Input
          id="validUntil"
          type="date"
          value={formData.validUntil}
          onChange={(e) => onUpdateFormData('validUntil', e.target.value)}
        />
      </div>
    </>
  );
};

export default BasicQuoteFields;